function triggerEcommerceAddToWishlistEvent(articleId) {
  const event = new CustomEvent("gtm_ecommerce_add_to_wishlist", {
    detail: {
      articleId,
      userType: "person",
    },
  });
  window.dispatchEvent(event);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する
window.triggerEcommerceAddToWishlistEvent = triggerEcommerceAddToWishlistEvent;

export default triggerEcommerceAddToWishlistEvent;